import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import { useTranslation } from 'react-i18next';
import { useStoreState, useStoreActions } from 'easy-peasy';


import { Row, Col } from "stories/layout";
import { Input } from "stories/forms";
import { Card, Typography, Button, Link, IconButton, Modal, Spinner, BreadcrumbsDynamic } from "stories/components";
import { PageWrapper, PageHeader,  PageContainer } from "components/Page"
import { TableAuto } from "stories/tables"
import LineChart from "stories/components/LineChart";
import { Pagination } from "stories/tables";
import { round,roundScaleDecimals, thousandFormat } from "services/helpers"




import PrivateInvestmentFundEdit from "views/app/PrivateInvestmentFundEdit/PrivateInvestmentFundEdit"
import { getDefaultOptions } from "date-fns";

const PrivateInvestmentFundsList = ({match, history, location}) => {
  
  const { t } = useTranslation();
  const privateInvestmentFunds = useStoreState((state) => state.privateInvestmentFunds?.objects);
  const loading = useStoreState((state) => state.privateInvestmentFunds?.loading);
  const getPrivateInvestmentFunds = useStoreActions((actions) => actions.privateInvestmentFunds.getObjects);
  const count = useStoreState((state) => state.privateInvestmentFunds?.count);

  let path = location.pathname.split("/").pop()
  if (path === "funds") {
    path = "private_investment_fund"
  }
  if (path === "stocks") {
    path = "private_stock"
  }
  // get location latest /path from location
  useEffect(() => {
    let path = location.pathname.split("/").pop()
    if (path === "funds") {
      path = "private_investment_fund"
    }
    if (path === "stocks") {
      path = "private_stock"
    }

    setFilters(f => ({
      ...f,
      type: path,
    }))

    if (location?.state?.newSecurity) {
      openModalEdit(location?.state?.newSecurity)
    } 
  }, [location])


  const [filters, setFilters] = useState({
    limit: 30,
    offset:0,
    type: path
  })
  
  useEffect(() => {
    getPrivateInvestmentFunds(filters)
  }, [filters])
  
  const handleChange = ({target}) => {
    setFilters({
      ...filters,
      [target.name]: target.value,
    })
  }
  
  const headers = [
    { label: t("PrivateInvestmentFundsList_name", "Name"), key: "name"},
    { label: t("PrivateInvestmentFundsList_symbol", "Symbol"), key: "symbol"},
    { label: t("PrivateInvestmentFundsList_price", "Viimeisin päätöshinta"), key: "latest_price"},
    { label: t("PrivateInvestmentFundsList_currency_label", "Currency"), key: "currency_label"},
    { label: t("PrivateInvestmentFundsList_latest_price_date", "Viimeisin kirjaus pvm"), key: "latest_price_date"},
    { label: t("PrivateInvestmentFundsList_size", "Size"), key: "size"},
    { label: t("PrivateInvestmentFundsList_datas_count", "Kirjauksia yht"), key: "datas_count"},
    // { label: t("PrivateInvestmentFundsList_seven_days", "Viimeisimmät 7 päivää"), key: "latest_seven_days"},
    { label: t("PrivateInvestmentFundsList_actions", " "), key: "actions"},
  ];
  
  const getOptions = () => {
    //options for chartjs
    const options = {


    };
    return options
  }



  const paginationPrevious = () => {
    let offset = filters?.offset - filters?.limit;
    if (offset < 0) {
      offset = 0;
    }
    setFilters(f => ({
      ...f,
      offset: offset,
    }))
  }
  
  const paginationNext = () => {
    let offset = filters?.offset + filters?.limit;
    if (offset > filters?.count) {
      return
    }
    setFilters(f => ({
      ...f,
      offset: offset,
    }))
  }

  const getCrumbLinks = () => {
    const crumbLinks = [
      {name: t("Etusivu"), url: "/dashboard/"},
      // {name: t("Rahastot"), url: "/dashboard/"},
      {name: t(location.pathname), url: location.pathname},
    ]

    //if location state include crumbLinks return them
    if (location?.state && location?.state?.crumbLinks) {
      const crumbLinks = [...location.state.crumbLinks] 
      crumbLinks.push({name: t(location.pathname), url: location.pathname})
      return crumbLinks
    }
    //else return default links
    return crumbLinks
  }
  
  // set Link-element state to crumbLinks
  const setCrumbLinks = (links) => {
    history.push({
      pathname: location.pathname,
      state: {
        crumbLinks: links,
      }
    })
  }


const getRowName = (row) => {
  return (
    <Link to={{pathname:"/dashboard/private_investment_funds/rates", state: {crumbLinks:getCrumbLinks(), fundId:row.id, fundName: row?.name, currency: row?.currency_label, path: filters?.type}}}>
    <h4 className=" text-dark m-0">
    {row?.name || "-"}
    </h4>
    </Link>
  )
}

// <div className="d-flex justify-content-center" style={{disblay:"block", boxSizing: "border-box", width:"150px", height: "40px"}}>
// <LineChart chartData={row.latest_data} options=""  />
// </div>
// number only get two decimals
const twoDigits = (number) => {
  number = Number(number)
  return number && number.toFixed(2)
}




  const getTableRows = useCallback(() => {
    return privateInvestmentFunds && privateInvestmentFunds.map((row, index) => {
      //copy row
      let newRow = {...row}

      //set row 
      if (row?.latest_data?.[0]) {
        newRow.latest_price = ( <div className="d-flex justify-content-end pr-1">{thousandFormat(roundScaleDecimals(row.latest_data?.[0]?.updated_price,2))}</div>)
        newRow.latest_price_date = moment(row.latest_data?.[0]?.date).format('DD.MM.YYYY') || "-"
      } else {
        newRow.latest_price = " "
        newRow.latest_price_date = " "
      }
      // newRow.size = ( <div >{twoDigits(row.size)}</div> || "-")
      newRow.size = row?.size && {
        content: thousandFormat(roundScaleDecimals(row.size,2)),
        className: "text-right"
      }
      newRow.datas_count =  {
        content: thousandFormat(row.datas_count),
        className: "text-right"
      }

      newRow.latest_seven_days = (    
        <div className="d-flex justify-content-center">
        <Link to={{pathname:"/dashboard/private_investment_funds/rates", state: {crumbLinks:getCrumbLinks(), fundId:row.id, fundName: row?.name}}}>
           <div className="" style={{disblay:"block", boxSizing: "border-box", width:"150px", height: "40px"}}><LineChart chartData={row.latest_data} options={getOptions()} defaultStartDaysNum="7" /> </div> {t("")}
        </Link>
        </div>
      )      
      return {
        ...newRow,
        actions: (
        <div className="d-flex justify-content-end">
        <Link to={{pathname:"/dashboard/private_investment_funds/rates", state: {crumbLinks:getCrumbLinks(), fundId:row.id, fundName: row?.name, currency: row?.currency_label,  path: filters?.type}}}>
          <Button className="btn-sm" color="secondary">
            <span className="fas fa-chart-line"></span> {t("")}
          </Button>
        </Link>
        <Button className="btn-sm ml-3" color="secondary" onClick={() => openModalEdit(row?.id)}>{t("Muokkaa")}</Button>
        </div>
        ),
      }
    })
  }, [privateInvestmentFunds, filters])
  
  // Modal: New/Edit
  
  const [modalEditOpen, setModalEditOpen] = useState(false)
  const [modalEditId, setModalEditId] = useState()
  
  const toggleModalEdit = () => {
    setModalEditOpen(s => !s);
  }
  
  const openModalEdit = (id) => {
    setModalEditOpen(true)
    setModalEditId(id);
  }
  
  const modalEditResolve = () => {
    setModalEditOpen(false);
    setModalEditId(null);
    getPrivateInvestmentFunds(filters)
  }
  
  const modalEditReject = () => {
    setModalEditOpen(false);
    setModalEditId(null);
  }
  

  return (
    <>
    <PageHeader title={t(location.pathname)} />
    <BreadcrumbsDynamic links={getCrumbLinks()} />
    {/* {JSON.stringify(location)} */}
    {/* {JSON.stringify(getCrumbLinks())} */}
    {/* {JSON.stringify(filters)} */}
    <PageContainer>
      <div className="py-3 pl-0 d-flex">
        <Button color="secondary" onClick={() => openModalEdit(null)}>{t("PrivateInvestmentFundsList_new","Uusi arvopaperi")}</Button>
        
        {  !loading && (
          <div className="d-flex align-items-center ml-auto">
            <div className="mx-2" variant="h4">{t("PrivateInvestmentFundsList_count", "Näytä")}</div>
            <Pagination 
              paginationOffset={filters?.offset}
              paginationLimit={filters?.limit}
              paginationCount={count}
              setFilters={setFilters}
              showPaginationCurrentPage={false}
              showPaginationNextAndPrevious={false}
              showVerticalBorders={false}
            />
            <div className="mx-2" variant="h4">{t("riviä")}</div>

          </div>
        )}
      </div>

        
      <TableAuto
        showRowNumber={true}
        showId={false}
        checkboxes={false}
        headers={headers}
        headerColor={"light"}
        rows={getTableRows().map((row, index) => {row.name = getRowName(row); return row})}
        loading={loading}
        pagination={true}
        paginationPrevious={paginationPrevious}
        paginationNext={paginationNext}
        paginationOffset={filters?.offset}
        paginationLimit={filters?.limit}
        paginationCount={count}
        setFilters={setFilters}
      />
      </PageContainer>
      <Modal
          title={t("PrivateInvestmentFundEdit_title", "Oma arvopaperi")}
          isOpen={modalEditOpen}
          toggleModal={toggleModalEdit}
          showHeader={false}
          size="modal-xl"
          classNameBody="p-0 padding-0"
        >
        <PrivateInvestmentFundEdit
          objectId={modalEditId}
          handleResolve={modalEditResolve}
          handleReject={modalEditReject}
        />
      </Modal>

    </>
  );
}

export default PrivateInvestmentFundsList;
